import Vue from 'vue';
import 'intersection-observer';
import App from './App.vue';
import router from './router';
import store from './store';
import Loader from './components/shared/loader/Loader.vue';
import Scroller from './components/shared/scroller/Scroller.vue';
import GravityGateway from './services/gravityGateway';
import StandaloneApp from './services/standaloneApp';
import './filters';
import './directives/maxHeight';
import './directives/goBack';
import './services/sentry';

Vue.component('Loader', Loader);
Vue.component('Scroller', Scroller);

Vue.config.productionTip = false;

const isStandaloneApp = window.location === window.parent.location;

const app = new Vue({
  router,
  store,
  render: h => h(App),
  beforeCreate() {
    if (isStandaloneApp) {
      StandaloneApp.init(store.dispatch);
      return;
    }

    if (window.location.pathname !== '/tickets') {
      GravityGateway.init({ dispatch: store.dispatch });
    }
  },
}).$mount('#app');

export default app;
